import { ProductNavigationModule } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';
import { DynamicComponentLoaderModule, LazyLoadingModule } from '@adaptiva/core/loaders';
import { TITLE_SUFFIX } from '@adaptiva/core/routing';
import { SummarizeModule } from '@adaptiva/core/summary';
import { NgModule } from '@angular/core';
import { DYNAMIC_HOSTING_COMPONENT_MANIFESTS } from '../../dynamic-hosting-components.manifest';
import { CLOUD_PORTAL_NAVIGATION, HOSTING_SUMMARIZABLE_CLASSES, MAS_PRODUCT_NAVIGATION, OPERATIONS_MANAGER_PRODUCT_NAVIGATION } from './constants';

@NgModule({
	imports: [
		SummarizeModule.register(HOSTING_SUMMARIZABLE_CLASSES),
		DynamicComponentLoaderModule.forRoot(DYNAMIC_HOSTING_COMPONENT_MANIFESTS),
		LazyLoadingModule.forChild({
			loaders: [
				{
					product: Licensing.Products.Internal.MAS,
					load: () => import('@adaptiva/metadata/lazy').then(m => m.MetadataClassLoaderModule)
				},
				{
					product: Licensing.Products.Internal.OPERATIONS_MANAGER,
					load: () => import('@adaptiva/operations-manager/lazy').then(m => m.OperationsManagerClassLoaderModule)
				},
				{
					product: Licensing.Products.Internal.CIM,
					load: () => import('@adaptiva/cloud-portal/lazy').then(m => m.CloudPortalClassLoaderModule),
				}
			]
		}),
		ProductNavigationModule.register([
			CLOUD_PORTAL_NAVIGATION,
			MAS_PRODUCT_NAVIGATION,
			OPERATIONS_MANAGER_PRODUCT_NAVIGATION,
		]),
	],
	providers: [
		{
			provide: TITLE_SUFFIX,
			useValue: 'Cloud Portal'
		},
	]
})
export class HostingModule {

}
